import { Copy, Package, Plus, Truck } from "@/components/icons";
import { Button } from "@/components/kit";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { Link } from "@tanstack/react-router";

export function DashboardQuickActions() {
  const canOrders = useActionPermission(["orders:read"]);
  const canManageOrders = useActionPermission(["orders:write"]);
  const canProducts = useActionPermission(["products:read"]);

  if (!canOrders && !canProducts) return null;

  return (
    <div
      className="flex flex-wrap gap-2"
      data-tourid="dashboard-quick-actions"
    >
      {canManageOrders ? (
        <Button asChild className="rounded-full">
          <Link to="/app/orders/new">
            <Plus />
            ສ້າງອໍເດີ້
          </Link>
        </Button>
      ) : null}
      {canOrders ? (
        <Button asChild variant="outline" className="rounded-full">
          <Link to="/app/fulfillment">
            <Truck />
            ຈັດສົ່ງ
          </Link>
        </Button>
      ) : null}
      {canProducts ? (
        <Button asChild variant="outline" className="rounded-full">
          <Link to="/app/products">
            <Package />
            ສິນຄ້າ
          </Link>
        </Button>
      ) : null}
      {canOrders ? (
        <Button asChild variant="outline" className="rounded-full">
          <Link to="/app/chat-snippets">
            <Copy />
            ຂໍ້ຄວາມແຊດ
          </Link>
        </Button>
      ) : null}
    </div>
  );
}
